import { TextAreaProps } from "antd/es/input";
import { StyledTextArea } from "./atom";

export function Textarea({ className, ...props }: TextAreaProps) {
  return (
    <StyledTextArea className={`renderbus-ui--input ${className}`} {...props} />
  );
}
